import { Component } from "@angular/core";
import { Location } from "@angular/common";
import { AuthService } from "projects/sepidz-web-framework/src/lib/services";
@Component({
  selector: "ng-auth",
  template: ` <router-outlet></router-outlet> `,
})
export class AuthComponent {
  authenticated: boolean = false;

  constructor(protected authService: AuthService, protected location: Location) {
    this.authenticated = this.authService.getIsLoggedIn();
  }
}
